import { handle420 } from 'apis/HandleError';
import { handleGenericError } from 'apis/HandleError';
import { apiConfig, appConfig } from 'config';

export function getCountersData(from, to, deviceIDs, counters, resolution, options = {}) {
  const auth = window.__APP_AUTH;
  let postBody = {
    searchSpan: {
      from: {
        dateTime: from
      },
      to: {
        dateTime: to
      }
    },
    devices: deviceIDs,
    counters: [...counters],
    resolution: resolution
  };

  let headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Origin: `${appConfig.webBaseUrl}/`,
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json',
    mode: 'cors'
  };

  return new Promise((resolve, reject) => {
    fetch(apiConfig.pmServiceGetCounters, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(postBody),
      ...options
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.json());
        } else if (response.status === 500) {
          reject('500');
        } else {
          //throw new Error();
          response.text().then((x) => {
            reject(x);
          });
        }
      })
      .catch((e) => {
        switch (e.message) {
          case '420':
            handle420();
            break;
          default:
            handleGenericError();
        }
        reject(e);
      });
  });
}
